import type { $Fetch } from "ofetch";

const controller = "/Validacao";

export default class ValidacaoApi {
  private api;

  constructor(api: $Fetch) {
    this.api = ((request: string, options: any = {}) => {
      return api(request, {
        ...options,
        headers: {
          ...this.authHeaders(),
          ...(options?.headers || {}),
        },
      });
    }) as $Fetch;
  }

  /** Usa o JWT público sem substituir a sessão administrativa da aplicação. */
  private authHeaders() {
    if (!import.meta.client) return {};

    const storedToken = localStorage.getItem("tokenAgendamento") || "";
    if (!storedToken) return {};

    return {
      Authorization: storedToken.startsWith("Bearer ")
        ? storedToken
        : `Bearer ${storedToken}`,
    };
  }

  verificarCodigo(codigo: string) {
    return this.api<boolean>(`${controller}/VerificarCodigo`, {
      method: "GET",
      params: { codigo },
    });
  }

  preencherDados(codigo: string) {
    return this.api<any>(`${controller}/PreencherDados`, {
      method: "GET",
      params: { codigo },
    });
  }
}
